import TileLayer from "ol/layer/Tile";
import {XYZ} from "ol/source";
import {get as getProjection} from "ol/proj";
import {getTopLeft, getWidth} from "ol/extent";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import {
    getLayerAttributes,
    getLayerNamePrefix,
    removeLoaderByBookmarkPresentationID
} from "@/helpers/ol/ol-layer-helper";
import TileGrid from "ol/tilegrid/TileGrid";
import {getTileGridByProjection} from "@/modules/ol/service/ol-service-wmts";
import {getViewProjectionByName} from "@/helpers/ol/ol-projection-helper";
import {scaleToResolution} from "@/helpers/ol/view/ol-view-resolutation-helper.js";

/**
 * Add Open Street Map
 * @param map
 * @param service
 */
export function addServiceXyz(map, service) {

    const source = new XYZ({
        url: service.Url,
        attributions: getLayerAttributes(service)
    })

    const layer = new TileLayer({
        minResolution: scaleToResolution(service.MinResolution),
        maxResolution: scaleToResolution(service.MaxResolution),
        opacity: service.Opacity / 10,
        name: getLayerNamePrefix() + service.id,
        zIndex: service.zIndex,
        source: source
    })

    map.addLayer(layer)

    removeLoaderByBookmarkPresentationID(service.id)

    return layer
}
